import React, { useState, useEffect, useRef } from "react";

import JobPostingSchema from "@/kyna/lib/validations/JobPostingSchema";
import { useFormik } from "formik";
import { KTPost } from "@/kyna/lib/db";
import InputForm from "@/kyna/forms/InputForm";
import { format } from "date-fns";
import HeaderNav from "../../includes/HeaderNav";
import Spinner from "@/kyna/ui/preloader/Spinner";
import KNPagination from "@/kyna/ui/pagination/KNPagination";
import Footer from "../../includes/Footer";

import toast from "react-hot-toast";
import { KNThemeSuccess, KNThemeError } from "@/kyna/ui/toaster/KNTheme";
import KNToaster from "@/kyna/ui/toaster/KNToaster";
import TextField from "@/kyna/forms/RichTextField/TextField";
import { useRouter } from "next/router";
import { useQuery } from "react-query";
import { KTGet } from "@/kyna/lib/db";
import JobCard from "./JobCard";

const CareersMenu = (props) => {
  const router = useRouter();
  const itemsPerPage = 10;
  const [totalCount, setTotalCount] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [skipStart, setSkipStart] = useState(1);
  const [skipEnd, setSkipEnd] = useState(itemsPerPage);

  const { data, isLoading, status } = useQuery(["CareerData", router.query], () => {
    return KTGet("/api/jobs", {
      orderBy: "id,desc",
      current_date: format(new Date(), "yyyy-MM-dd"),
      limit: itemsPerPage,
      page: router.query?.page,
    });
  });

  const handlePageClick = (event) => {
    const pageNumber = event.selected + 1;
    console.log("SKIP / OFFSET", pageNumber);
    router.push({
      pathname: "/careers",
      query: {
        ...router.query,
        page: pageNumber,
      },
    });

    const totalLoaded = pageNumber * itemsPerPage;
    console.log("totalLoaded", totalLoaded);
    setSkipStart(totalLoaded - (itemsPerPage - 1));

    if (totalLoaded > totalCount) {
      setSkipEnd(totalCount);
    } else {
      setSkipEnd(totalLoaded);
    }
  };

  useEffect(() => {
    console.log("pageCount", pageCount);
    const totalCountRes = parseInt(data?.data?.info?.totalCount)
      ? parseInt(data.data.info.totalCount)
      : 0;
    const NewPageCount = Math.ceil(totalCountRes / itemsPerPage);
    setTotalCount(totalCountRes);
    setPageCount(NewPageCount);
    if (totalCountRes && skipEnd > totalCountRes) {
      setSkipEnd(totalCountRes);
    }
  }, [data]);

  return (
    <>
      {/* MAIN NAV */}
      <HeaderNav />

      {/* Contact Page Section */}
      <section className="max-w-screen-2xl mx-auto pb-14 sm:px-10 px-8 mt-28">
        <div className="grid grid-cols-1">
          <div className="col-span-1 ">
            <div className="lg:pt-14 pt-8 text-center">
              <h1 className="text-blue sm:text-4xl text-3xl leading-normal mb-3">Careers</h1>
              <p className="font-CantoraOne text-gray-700 text-center md:text-2xl text-xl">Join our growing team and be part of our advocacy!</p>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-screen-2xl mx-auto pb-24 sm:px-10 px-8">
        <div className="grid grid-cols-1">
          <div className="col-span-1">
            <div className="max-w-4xl mx-auto text-justify">
              <p className="text-base">
                {
                  data?.data?.result?.length == 0 && status === "success" &&
                  "Unfortunately, we have no job vacancies as of the moment. However, you may send a copy of your resume/CV to careers@pmha.org.ph so that we could add you to our talent pool and notify you in case that we have a job opening for which you would be qualified. Thank you and best of luck on your job search!"
                }
              </p>
            </div>
          </div>
        </div>

        <div className="max-w-screen-lg mx-auto">
          {isLoading ? (
            <Spinner svgClass={"!text-gray-500"} isLoading={isLoading} />
          ) : data?.data?.result != "" ? (
            data?.data?.result?.map((job, index) => {
              return (
                <JobCard
                  key = {`job-${index}`}
                  title = {job.title}
                  companyName = {job.company_name}
                  /* companyAddress={job.company_address} */
                  minSalaryOffer = {job.min_salary_offer}
                  maxSalaryOffer = {job.max_salary_offer}
                  routes_id = {job.slug}
                  jobType = {job.job_type}
                  noOpening = {job.no_of_openings}
                  endFiling = {job.schedule}
                  branchName = {job.branch.name}
                  imgURL = {job.media?.path}
                />
              );
            })
          ) : null}
          <KNToaster />

          {/* <pre>{JSON.stringify(data?.data?.result,null,1)}</pre> */}
        </div>
        {totalCount == 10 && (
            <section className="bg-white mt-10 py-5 pb-3 border-t border-gray-200 px-5 xl:px-8 2xl:px-10">
              <KNPagination
                pageCount={pageCount}
                skipStart={skipStart}
                skipEnd={skipEnd}
                totalCount={totalCount}
                initialPage={
                  router.query?.page ? router.query.page - 1 : undefined
                }
                handlePageClick={handlePageClick}
              />
            </section>
          )}
      </section>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default CareersMenu;
